export const stringAvatar = (name: string) => {
  var names = name.split(' '),
    initials = names[0].substring(0, 1).toUpperCase()

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  }
  return {
    children: initials,
  }
}

export const getTrimmedText = (str: string, maxLength: number) => {
  if (str.length <= maxLength) return str
  return `${str.slice(0, maxLength - 5)}...${str.slice(-10)}`
}
